/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SMSearchListQuery
 */
export interface SMSearchListQuery {
    /**
     * 
     * @type {string}
     * @memberof SMSearchListQuery
     */
    ruleId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SMSearchListQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SMSearchListQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SMSearchListQuery
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SMSearchListQuery
     */
    details?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SMSearchListQuery
     */
    supplier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SMSearchListQuery
     */
    carrier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SMSearchListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SMSearchListQuery
     */
    limit?: number | null;
}

export function SMSearchListQueryFromJSON(json: any): SMSearchListQuery {
    return SMSearchListQueryFromJSONTyped(json, false);
}

export function SMSearchListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SMSearchListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ruleId': !exists(json, 'ruleId') ? undefined : json['ruleId'],
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'details': !exists(json, 'details') ? undefined : json['details'],
        'supplier': !exists(json, 'supplier') ? undefined : json['supplier'],
        'carrier': !exists(json, 'carrier') ? undefined : json['carrier'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function SMSearchListQueryToJSON(value?: SMSearchListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ruleId': value.ruleId,
        'showDisabled': value.showDisabled,
        'showDeleted': value.showDeleted,
        'description': value.description,
        'details': value.details,
        'supplier': value.supplier,
        'carrier': value.carrier,
        'offset': value.offset,
        'limit': value.limit,
    };
}


